import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Download } from 'lucide-react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

import { Button, Tooltip } from '@getro/rombo';
import { useDownloadHiresMutation } from '../../services/hires';
import { trackEvent } from '../../helpers/analytics';
import { activeNetworkSelector } from '../../redux/selectors';

export const Actions = () => {
  const [downloadHires, { isLoading }] = useDownloadHiresMutation();
  const activeNetwork = useSelector(activeNetworkSelector);

  const onClickDownload = async () => {
    await downloadHires();

    toast('Export in progress — we’ll email it to you in a few minutes.', { icon: 'success', id: 'download_hires' });
    trackEvent('hires:export_hires', { collection_id: activeNetwork.id });
  };

  return (
    <Flex alignItems="center" justifyContent="flex-end">
      <Tooltip
        content="Export a CSV to your inbox"
        position="top-start"
        sx={{
          minWidth: 'max-content !important',
          '.tooltip-arrow': { left: '35px !important' },
        }}
        trigger={
          <Button
            data-testid="button-download"
            alignItems="center"
            variant="tertiary"
            size="small"
            onClick={onClickDownload}
            sx={{ cursor: 'pointer', ':hover': { bg: 'neutral.10' } }}
            loading={isLoading}
          >
            <Box as={Download} mr="8px" width="16px" height="16px" aria-hidden="true" />
            <Text fontSize="12px" fontWeight="medium">
              Export
            </Text>
          </Button>
        }
      />
    </Flex>
  );
};
